export const LANDING_COLORS = {
  navy: '#22344A',
  navyDeep: '#1A2839',
  charcoal: '#2C2A26',
  terracotta: '#A15C43',
  terracottaDeep: '#8A4B35',
  terracottaLight: '#D9937A',
  sand: '#F5F2EE',
  paper: '#FFFFFF',
  line: 'rgba(34, 52, 74, 0.14)',
  lineSoft: 'rgba(34, 52, 74, 0.08)',
  muted: 'rgba(44, 42, 38, 0.72)',
  onDark: '#F5F2EE',
  onDarkMuted: 'rgba(245, 242, 238, 0.72)',
  onDarkLine: 'rgba(245, 242, 238, 0.16)',
};

export const landingEyebrowSx = {
  display: 'block',
  fontSize: '0.7rem',
  fontWeight: 600,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  lineHeight: 1.6,
  color: LANDING_COLORS.terracotta,
};

export const landingSectionSx = {
  py: { xs: 8, md: 12 },
  scrollMarginTop: 72,
};

export const landingTitleSx = {
  fontWeight: 700,
  letterSpacing: '-0.025em',
  lineHeight: 1.12,
  color: LANDING_COLORS.navy,
  fontSize: { xs: '1.8rem', sm: '2.1rem', md: '2.5rem' },
};

export const landingBodySx = {
  color: LANDING_COLORS.muted,
  lineHeight: 1.75,
  fontSize: { xs: '0.95rem', md: '1rem' },
};

/**
 * Hairline grid: the 1px gap exposes the container background as separator lines,
 * so cells must keep a solid background of their own.
 */
export const hairlineGridSx = (columns, backgroundColor = LANDING_COLORS.paper) => ({
  display: 'grid',
  gridTemplateColumns: columns,
  gap: '1px',
  background: LANDING_COLORS.line,
  border: `1px solid ${LANDING_COLORS.line}`,
  '& > *': { background: backgroundColor },
});
